import React from "react";
import { useTheme } from "../../providers/theme-provider";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import spacings from "../../theme/spacings";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { assetIcons, assetImages } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";

const Testimonials = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const isSmall = width < 768;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;

  const testimonials = [
    {
      text: t("testimonials.review1"),
      author: t("testimonials.author1"),
      location: t("testimonials.location1"),
      image: assetImages.user,
    },
    {
      text: t("testimonials.review2"),
      author: t("testimonials.author2"),
      location: t("testimonials.location2"),
      image: assetImages.user,
    },
    // Add more testimonials as needed
  ];

  const sliderRef = React.useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const goToPrev = () => {
    sliderRef.current.slickPrev();
  };

  const goToNext = () => {
    sliderRef.current.slickNext();
  };

  return (
    <div
      style={{
        backgroundColor: colors.heroBg,
        paddingLeft: paddingLeftRight,
        paddingRight: paddingLeftRight,
        paddingTop: paddingTopBottom,
        paddingBottom: paddingTopBottom,
      }}
      className="max-w-[1400px] mx-auto "
      id="testimonials"
    >
      <div className="flex flex-col relative md:flex-row justify-end items-center gap-8 px-4 py-9 max-w-7xl mx-auto">
        {/* Left Image */}
        <div className="absolute top-10 left-0 xl:w-auto w-1/2">
          <img
            src={assetImages.reviews}
            alt="Modern interior"
            className="xl:w-[600px] xl:h-[500px] object-cover rounded-lg"
          />
        </div>

        <div className="flex gap-4 absolute bottom-9 left-0">
          <button
            onClick={goToPrev}
            className="w-12 h-12 rounded-sm bg-gray-200 flex items-center justify-center transition-colors"
            aria-label="Previous slide"
          >
            <img
              src={assetIcons.arrowPrevious}
              alt="previous-arrow"
              className="w-5"
            />
          </button>
          <button
            onClick={goToNext}
            className="w-12 h-12 rounded-sm bg-gray-200 flex items-center justify-center transition-colors"
            aria-label="Next slide"
          >
            <img src={assetIcons.arrowNext} alt="arrow-next" className="w-5" />
          </button>
        </div>

        {/* Right Content */}
        <div className="w-full md:w-[85%] relative">
          <div className="flex justify-end">
            <h2
              className="xl:max-w-md max-w-xs font-semibold xl:mb-6 lg:mb-14 min-[912px]:mb-16 mb-14 xl:mr-8 min-[912px]:mr-14 mr-3"
              style={{
                fontSize: fontSizes.heading2,
                color: colors.mainHeading,
              }}
            >
              {t("testimonialsHeading")}
            </h2>
          </div>

          {/* Carousel */}
          <div className="">
            <Slider ref={sliderRef} {...settings}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="outline-none ">
                  <div className="bg-[#1C1C1C] min-[912px]:px-8 px-4 xl:py-[73px] lg:py-[48px] min-[912px]:py-[52px] py-[32px] rounded-lg xl:mx-5 mx-3 flex flex-col justify-center xl:gap-12 lg:gap-8 min-[912px]:gap-12 gap-8">
                    {/* Quote Icon */}
                    <img
                      src={assetIcons.doubleQuotes}
                      alt=""
                      className="min-[912px]:w-12 w-8"
                    />

                    {/* Testimonial Text */}
                    <p
                      className="text-white  leading-relaxed"
                      style={{
                        fontSize: fontSizes.body,
                      }}
                    >
                      {testimonial.text}
                    </p>

                    {/* Author */}
                    <div className="flex items-center gap-4">
                      <img
                        src={testimonial.image}
                        alt={testimonial.author}
                        className="w-12 h-12 rounded-full"
                      />
                      <div className="flex flex-col gap-2">
                        <span className="text-white font-medium">
                          {testimonial.author}
                        </span>
                        <span className="text-gray-300 text-sm">
                          {testimonial.location}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* Navigation Buttons */}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
